module.exports = __webpack_public_path__ + "img/fi-rr-e-learning.ab9c217d.svg";